var app = angular.module('leonardo');

/**
 * ShareAttachmentController
 * 
 * Handles shared attachment links. When a user visits a share URL:
 * 1. The 'authenticated' parent state ensures they are logged in (redirects to login if not)
 * 2. This controller fetches the file from the authenticated API endpoint
 * 3. Triggers an immediate download of the file
 */
var ShareAttachmentController = function($scope, $stateParams, $http, $window, ConfigThemeService, NotificationService) {
  var attachmentId = $stateParams.id;
  // Handle trailing slash in id
  if (attachmentId && attachmentId.endsWith('/')) {
    attachmentId = attachmentId.slice(0, -1);
  }
  
  // console.log('[ShareAttachment] Controller initialized, id:', attachmentId);
  
  $scope.loading = true;
  $scope.error = null;
  $scope.fileName = 'attachment';

  if (!attachmentId) {
    // console.error('[ShareAttachment] No attachment id provided');
    $scope.loading = false;
    $scope.error = 'Invalid attachment link';
    return;
  }

  // Fetch the file from the authenticated API endpoint
  var apiUrl = ConfigThemeService.generateURL('/api/2.0/attachments/' + attachmentId + '/download/');
  // console.log('[ShareAttachment] Fetching from:', apiUrl);

  $scope.retryDownload = function() {
    // console.log('[ShareAttachment] Retrying download for id:', attachmentId);
    $scope.loading = true;
    $scope.error = null;
    $scope.downloadComplete = false;
    
    // Re-execute the download request
    $http({
      method: 'GET',
      url: apiUrl,
      responseType: 'blob'
    }).then(function(response) {
      // console.log('[ShareAttachment] Response received, status:', response.status);
      $scope.loading = false;
      
      // Extract filename from Content-Disposition header if available
      var contentDisposition = response.headers('Content-Disposition');
      if (contentDisposition) {
        var matches = contentDisposition.match(/filename="?([^";\n]+)"?/);
        if (matches && matches[1]) {
          $scope.fileName = matches[1];
        }
      }

      // Create blob URL and download
      var blob = response.data;
      var blobUrl = $window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = blobUrl;
      link.download = $scope.fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      $window.URL.revokeObjectURL(blobUrl);
      $scope.downloadComplete = true;
      // console.log('[ShareAttachment] Download triggered for:', $scope.fileName);
    }, function(error) {
      console.error('[ShareAttachment] Error:', error.status, error);
      $scope.loading = false;
      
      if (error.status === 401) {
        $scope.error = 'You do not have permission to access this attachment.';
      } else if (error.status === 404) {
        $scope.error = 'This attachment could not be found.';
      } else {
        $scope.error = 'An error occurred while downloading the attachment.';
      }
      
      NotificationService.error($scope.error);
    });
  };

  $scope.goHome = function() {
    $window.location.href = '#/';
  };

  // Initial download attempt
  $http({
    method: 'GET',
    url: apiUrl,
    responseType: 'blob'
  }).then(function(response) {
    // console.log('[ShareAttachment] Response received, status:', response.status);
    $scope.loading = false;
    
    // Extract filename from Content-Disposition header if available
    var contentDisposition = response.headers('Content-Disposition');
    if (contentDisposition) {
      var matches = contentDisposition.match(/filename="?([^";\n]+)"?/);
      if (matches && matches[1]) {
        $scope.fileName = matches[1];
      }
    }

    // Create blob URL and download
    var blob = response.data;
    var blobUrl = $window.URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.href = blobUrl;
    link.download = $scope.fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    $window.URL.revokeObjectURL(blobUrl);
    $scope.downloadComplete = true;
    // console.log('[ShareAttachment] Download triggered for:', $scope.fileName);
  }, function(error) {
    console.error('[ShareAttachment] Error:', error.status, error);
    $scope.loading = false;
    
    if (error.status === 401) {
      $scope.error = 'You do not have permission to access this attachment.';
    } else if (error.status === 404) {
      $scope.error = 'This attachment could not be found.';
    } else {
      $scope.error = 'An error occurred while downloading the attachment.';
    }
    
    NotificationService.error($scope.error);
  });
};

app.controller('ShareAttachmentController', [
  '$scope', '$stateParams', '$http', '$window', 'ConfigThemeService', 'NotificationService',
  ShareAttachmentController
]);
